/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getFileVideoObject = state => state.upload.videoObject;
